function removeFromParent(obj) {
    if (obj.parent) {
        const parent = obj.parent;
        obj.parent = undefined;
        const i = parent.children.indexOf(obj);
        parent.children.splice(i, 1);
    }
}

export { removeFromParent };
//# sourceMappingURL=remove-from-parent.js.map
